import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { DATE_FORMAT, DATE_TIME_FIELDS, DATE_TIME_FORMAT } from "src/app/invopay/constants/date-constants";
import { IpConfigurationParameterKeys } from "src/app/invopay/constants/ip-configuration-parameter-key";
import { IpConfigurationParametersService } from "src/app/invopay/services/ip-configuration-parameters.service";

@Injectable({
    providedIn: 'root',
})
export class DateService {
    dateFormat = DATE_FORMAT;
    dateTimeFormat = DATE_TIME_FORMAT;
    dateTimeFields = DATE_TIME_FIELDS;
    constructor(
        private readonly datePipe: DatePipe,
        private readonly configurationParametersService: IpConfigurationParametersService
    ) {
        this.loadFromConfigurationParameters();
    }

    fromServerDate(date?: string | null | Date): Date | null {
        if (!date) {
            return null;
        }
        if (date instanceof Date) {
            return date;
        }
        return new Date(date + 'Z');
    }

    fromServerDateStrDate(date?: string | null | Date, format?: string): string | null {
        if (!date) {
            return null;
        }
        return this.datePipe.transform(this.fromServerDate(date), format || this.dateFormat || 'YYYY-MM-dd');
    }

    fromServerDateStrDateTime(date?: string | null | Date, format?: string): string | null {
        if (!date) {
            return null;
        }
        return this.datePipe.transform(this.fromServerDate(date), format || this.dateTimeFormat || 'YYYY-MM-ddTHH:mm:ss');
    }

    toServerDate(date?: Date | string | null): string | undefined {
        let serverDate;
        if (date instanceof Date) {
            serverDate = date.toISOString();
        } else if (typeof date === 'string') {
            serverDate = this.datePipe.transform(date, 'YYYY-MM-ddTHH:mm:ss', 'UTC');
        }
        if (serverDate) {
            return serverDate.slice(0, 23);
        }
        return undefined;

    }

    tableTransform(data: any, key: string) {
        if (this.dateTimeFields.includes(key)) {
            return this.datePipe.transform(data + 'Z', this.dateTimeFormat);
        }
        return this.datePipe.transform(data + 'Z', this.dateFormat);
    }


    toInitialDayServerDate(date?: Date | string): string | undefined {
        if (!date) {
            return undefined;
        }
        const initialDay = new Date(date + 'T00:00:00.000');
        return this.toServerDate(initialDay);
    }

    toFinalDayServerDate(date: Date | string): string | undefined {
        if (!date) {
            return undefined;
        }
        const finalDay = new Date(date + 'T23:59:59.999');
        return this.toServerDate(finalDay);
    }

    isDate(data: string): boolean {
        if (typeof data !== 'string') {
            return false;
        }
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        const slicedDate = data.slice(0, 10);
        return dateRegex.test(slicedDate);
    }


    private loadFromConfigurationParameters() {
        this.configurationParametersService.parameters$.subscribe(params => {
            if (params) {
                const dateFormatParam = params.find(param => param.key === IpConfigurationParameterKeys.DATE_FORMAT);
                const dateTimeFormatParam = params.find(param => param.key === IpConfigurationParameterKeys.DATE_TIME_FORMAT);
                const dateTimeFieldsParam = params.find(param => param.key === IpConfigurationParameterKeys.DATE_TIME_FIELDS);
                if (dateFormatParam) {
                    this.dateFormat = dateFormatParam.value;
                }
                if (dateTimeFormatParam) {
                    this.dateTimeFormat = dateTimeFormatParam.value;
                }
                if (dateTimeFieldsParam) {
                    this.dateTimeFields = dateTimeFieldsParam.value.split(',').map(field => field.trim());
                }
            }
        });
    }
}